export const GET_SETTINGS_STARTED = "GET_SETTINGS_STARTED";
export const GET_SETTINGS_SUCCESS = "GET_SETTINGS_SUCCESS";
export const GET_SETTINGS_FAILED = "GET_SETTINGS_FAILED";
export const SAVING_ACCOUNT_ARREARS = "SAVING_ACCOUNT_ARREARS";
export const UPDATED_SETTINGS = "UPDATED_SETTINGS"; // Add this line
export const UPDATED_ACCOUNT_ARREARS_SYSTEM_RULES = "UPDATED_ACCOUNT_ARREARS_SYSTEM_RULES";
export const UPDATED_ACCOUNT_ARREARS_GUEST_RULES = "UPDATED_ACCOUNT_ARREARS_GUEST_RULES";
export const SAVING_ACCOUNT_ARREARS_GUEST_RULES = "SAVING_ACCOUNT_ARREARS_GUEST_RULES";
